import * as React from "react"

interface PreHeroProps {
	type?: any
}
const PreHero: React.FC<PreHeroProps> = ({ type }) => {
	return (
		<section className=" lg:bg-center-bottom relative top-0 z-[10] mx-auto h-[540px] w-full bg-[url('/src/bgimages/danke-bg.png')] bg-cover bg-center lg:-mt-[11rem] lg:h-[750px] lg:bg-white dankebefore pointer-events-none">
			<div className="mx-auto grid max-w-[1400px] py-0 lg:mt-[180px] lg:grid-cols-2 lg:px-12 lg:py-0">
				<div className="mt-12 px-12 py-6 lg:mt-24 lg:px-0 lg:py-0">
					<p className="text-center font-Veener text-[32px] text-green lg:text-[62px]">Vielen Dank für die Teilnahme an unserer GRATIS-TESTEN-AKTION.</p>
				</div>
				<div className="lg:mt-24">
					<img src={"/images/dosen-danke.png"} className="w-[75%] md:w-[100%] mx-auto relative z-[2]" />
				</div>
			</div>
		</section>
	)
}

export default PreHero
